<template>
  <div>
    <footer>
      <button id="scrollUp" class="back-to-top">
        <i class="fa fa-chevron-up"></i>
      </button>
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <div class="mb-2">
              <img
                style="max-width: 173px"
                src="/App_Themes/images/variphone-footer-logo.png"
                alt="logo variphone"
              />
            </div>
            <ul style="list-style-type: none; margin-left: 0">
              <li>
                <a
                  class="text-white"
                  :href="`https://variphone.com/${$store.state.language}/about-variphone`"
                  target="_BLANK"
                  >{{ $t("about-us") }}</a
                >
              </li>
              <li>
                <a
                  class="text-white"
                  :href="`https://variphone.com/${$store.state.language}/contact/`"
                  target="_BLANK"
                  >{{ $t("contact") }}</a
                >
              </li>
              <li>
                <a
                  class="text-white"
                  :href="`https://variphone.com/${$store.state.language}/measuring-ears`"
                  target="_BLANK"
                  >{{ $t("working-method") }}</a
                >
              </li>
              <li class="mt-3">
                <a
                  class="text-white"
                  :href="`https://variphone.com/${$store.state.language}/general-conditions`"
                  target="_BLANK"
                  >{{ $t("general") }}</a
                >
              </li>
              <li>
                <a
                  class="text-white"
                  :href="`https://variphone.com/${$store.state.language}/privacy-policy`"
                  target="_BLANK"
                  >{{ $t("privacy-policy") }}</a
                >
              </li>
            </ul>
          </div>
          <div class="address col-12 col-md-6 col-lg-3">
            <div class="mb-3 mt-1">
              <strong class="text-warning">{{ $t("follow-us-on") }}</strong>
            </div>
            <div class="mb-2">
              <a href="https://www.facebook.com/variphone/" target="_BLANK">
                <img
                  style="width: 40px"
                  src="/img/Facebook.svg?data"
                  alt="facebook"
                />
              </a>
            </div>
            <div class="mb-2">
              <a href="https://www.youtube.com/user/Variphone" target="_BLANK">
                <img
                  style="width: 40px"
                  src="/img/YouTube.svg?data"
                  alt="youtube"
                />
              </a>
            </div>
            <div class="mb-2">
              <a href="https://twitter.com/variphone?lang=en" target="_BLANK"
                ><img
                  style="width: 40px"
                  src="/img/Twitter.svg?data"
                  alt="twitter"
                />
              </a>
            </div>
            <div class="mb-2">
              <a href="https://www.instagram.com/variphone" target="_BLANK"
                ><img
                  style="width: 40px"
                  src="/img/Instagram.svg?data"
                  alt="instagram"
              /></a>
            </div>
          </div>
          <div class="address col-12 col-md-6 col-lg-3">
            <div class="mb-3 mt-1">
              <strong class="text-warning">{{ $t("payment-methods") }}</strong>
            </div>
            <div class="mb-2">
              <div class="mb-2">
                <img
                  style="height: 30px"
                  src="/img/iDEAL.svg?data"
                  alt="ideal"
                />
              </div>
              <div class="mb-2">
                <img
                  style="height: 15px"
                  src="/img/mastercard.svg?data"
                  alt="ideal"
                />
              </div>
              <div class="mb-2">
                <img
                  style="height: 15px"
                  src="/img/maestro.svg?data"
                  alt="maestro"
                />
              </div>
              <div class="mb-2">
                <img style="height: 15px" src="/img/Visa.svg?data" alt="visa" />
              </div>
              <div>
                <img
                  style="height: 15px"
                  src="/img/PayPal.svg?data"
                  alt="paypal"
                />
              </div>
            </div>
          </div>

          <div class="address col-12 col-md-6 col-lg-3">
            <div class="mb-3 mt-1">
              <strong class="text-warning">{{ $t("delivery-methods") }}</strong>
            </div>
            <div class="mb-2">
              <div class="mb-2">
                <img
                  style="height: 35px"
                  src="/img/bpost.svg?data"
                  alt="bpost"
                />
              </div>
              <div class="mb-2">
                <img style="height: 30px" src="/img/dpd.svg?data" alt="dpd" />
              </div>
              <div class="mb-2">
                <img style="height: 35px" src="/img/UPS.svg?data" alt="ups" />
              </div>
              <div class="mb-2">
                <img
                  style="height: 20px"
                  src="/img/FedEx.svg?data"
                  alt="fedex"
                />
              </div>
              <div>
                <img style="height: 20px" src="/img/TNT.svg?data" alt="tnt" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "ShopFooter",
}
</script>

<style>
.address {
  display: flex;
  flex-direction: column;
}

.mt-a {
  margin-top: auto;
}
</style>
